import { useQuery } from '@tanstack/react-query';
import { getVirtualMedicine } from '../requests';
import { VirtualMedicine } from '../types';

interface UseVirtualMedicineReturn {
  virtualMedicine?: VirtualMedicine | null;
  isLoading: boolean;
}

const useVirtualMedicine = (id: string): UseVirtualMedicineReturn => {
  const isEnabled = id !== 'create';

  const { data, isLoading } = useQuery({
    queryFn: () => getVirtualMedicine(id),
    queryKey: ['virtual-medicine', id],
    enabled: isEnabled,
  });

  const virtualMedicine = data?.data.data;
  const isArray = Array.isArray(virtualMedicine);

  return {
    virtualMedicine: virtualMedicine && !isArray ? virtualMedicine  : null,
    isLoading: isEnabled && isLoading,
  };
};

export default useVirtualMedicine;
